<template lang="">
  <div class="main" style="background: white">
    <div class="container1">
      <div class="top">
        <div class="item">
          <div>
            <h3>查询总量</h3>
            <span v-text="gross"></span>
          </div>
        </div>
        <div class="item">
          <div>
            <h3>今日查询总量</h3>
            <span v-text="dayGross"></span>
          </div>
        </div>
      </div>
      <!-- <div id="container"></div> -->
      <div
        :id="main1"
        style="width: calc(100% - 300px); height: 100%; float: right"
      ></div>
    </div>
  </div>
</template>
<script>
import { getStat, getOneDayStat } from "@/api/index";
import * as echarts from "echarts";
import "@/assets/js/china.js";
export default {
  data() {
    return {
      position: {},
      gross: 0,
      dayGross: 0,
      points: [["广东", 1000]], //各个省份下的客户数量
      maxDate: "",
      tableData: [],
      data_list: null,
      main1: 0
    };
  },
  computed: {
    GDkey() {
      return this.$store.state.gd.key;
    },
    GDsecret() {
      return this.$store.state.gd.secret;
    },
    GDmap() {
      return this.$store.state.gd.map;
    },
  },
  watch: {
  },
  mounted() {
    this.main1 = Math.random()
    getStat().then((res) => {
      this.data_list = res;
      // this.getRatioData();
      var myChart = echarts.init(document.getElementById(this.main1));
      var option = {
        tooltip: {
          // show: false, //不显示提示标签
          formatter: "{c}", //提示标签格式
          backgroundColor: "#FFF", //提示标签背景颜色
          textStyle: { color: "#009fe8" }, //提示标签字体颜色
        },
        series: [
          {
            type: "map",
            mapType: "china",
            label: {
              normal: {
                show: true, //显示省份标签
                textStyle: { color: "#009fe8" }, //省份标签字体颜色
              },
              emphasis: {
                //对应的鼠标悬浮效果
                show: true,
                textStyle: { color: "#009fe8" },
              },
            },
            itemStyle: {
              normal: {
                borderWidth: 0.5, //区域边框宽度
                borderColor: "#FFF", //区域边框颜色#009fe8
                areaColor: "#EEE", //区域颜色
              },
              emphasis: {
                //鼠标移入颜色
                borderWidth: 0.5,
                borderColor: "#FFF",
                areaColor: "#CCC", //鼠标移入颜色#1b2d35
                label: {
                  show: true,
                  textStyle: {
                    color: "#fff",
                  },
                },
              },
            },
            select: {
              // 地图选中区域样式
              label: {
                // 选中区域的label(文字)样式
                color: "#fff",
              },
              itemStyle: {
                // 选中区域的默认样式#0075FF
                areaColor: "#AAA",
              },
            },
            series: [
              {
                name: "数据",
                type: "map",
                mapType: "china",
                roam: false,
                itemStyle: {
                  normal: { label: { show: true } },
                  emphasis: { label: { show: true } },
                },
                data: res,
              },
            ],
            data: res,
          },
        ],
      };
      myChart.setOption(option);
      myChart.on("mouseover", function (params) {
        var dataIndex = params.dataIndex;
        // console.log(params);
      });
    });
    // if (this.$store.state.gd.key !== "") {
    //   this.gd(
    //     this.$store.state.gd.key,
    //     this.$store.state.gd.secret,
    //     this.$store.state.gd.map
    //   );
    // }
    getOneDayStat().then((res) => {
      this.gross = res[0];
      this.dayGross = res[1];
    });
  },
  methods: {
  },
};
</script>
<style scoped>
body {
  padding: 0;
  margin: 0;
}

#container {
  width: 100%;
  height: 100%;
  position: relative;
}

.container1 {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;


}

.container1>.top {
  position: absolute;
  top: 75px;
  margin-left: 15px;
  background: white;
  width: 250px;
  height: auto;
  display: flex;
  flex-direction: row;
  z-index: 999999;
}

.container1>.top>.item {
  width: 300px;
  background: white;
  border-radius: 8px;
  height: 100px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.container1>.top>.item>div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

}

.item>span {
  font-size: 24px;
}
</style>
